'use client';

import ProductCard from '@/components/products/ProductCard';
import { Grid, GridItem } from '@skin-seoul/design-system';
import { forwardRef } from 'react';
export const ProductGrid = forwardRef<HTMLDivElement, React.ComponentProps<typeof Grid>>((props, ref) => <Grid ref={ref} templateColumns={{
  desktop: 'repeat(5, minmax(0, 1fr))',
  base: 'repeat(2, minmax(0, 1fr))'
}} css={{
  '& > *:nth-of-type(n+5)': {
    display: 'none'
  }
}} desktop={{
  '& > *:nth-of-type(n+5)': {
    display: 'initial'
  }
}} width="100%" gap={{
  base: 3,
  desktop: 4
}} {...props} />);
export const ProductGridSkeleton = ({
  length = 5
}: {
  length?: number;
}) => {
  return <ProductGrid data-sentry-element="ProductGrid" data-sentry-component="ProductGridSkeleton" data-sentry-source-file="ProductGrid.tsx">
      {Array.from({
      length
    }).map((_, index) => <GridItem key={index} minWidth={0}>
          <ProductCard.Skeleton orientation="vertical" width="100%" />
        </GridItem>)}
    </ProductGrid>;
};